import axiosInstance from "./axiosInstance";

const adminService = {
  login: async (payload) => {
    try {
      const response = await axiosInstance.post("admin/users/login", payload);
      console.log("Response from login API:", response);
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },
  getAllRoles: async () => {
    try {
      const response = await axiosInstance.get("admin/users/roles");
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },
  getAllAdminPanelUsers: async (page) => {
    try {
      const response = await axiosInstance.get(
        `admin/users/admin-panel-users/${page}`
      );
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },
  createAdminPanelUser: async (payload) => {
    try {
      const response = await axiosInstance.post(
        "admin/users/register",
        payload
      );
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },
  getAdminPanelUserById: async (id) => {
    try {
      const response = await axiosInstance.get(
        `admin/users/admin-panel-user/${id}`
      );
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },
  updateAdminPanelUser: async (id, payload) => {
    try {
      const response = await axiosInstance.put(
        `admin/users/admin-panel-user/${id}`,
        payload
      );
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },
  deleteAdminPanelUser: async (id) => {
    try {
      const response = await axiosInstance.delete(
        `admin/users/admin-panel-user/${id}`
      );
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },
  logout: async () => {
    try {
      const response = await axiosInstance.post("admin/users/logout");
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },
  sendFilteredNotification: async (payload) => {
    try {
      const response = await axiosInstance.post(
        "admin/users/send-filtered-notification",
        payload
      );
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },
  getDistinctCountries: async () => {
    try {
      const response = await axiosInstance.get(
        "admin/users/distinct-countries"
      );
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },
  getNotificationHistory: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append("page", params.page);
      if (params.limit) queryParams.append("limit", params.limit);
      if (params.type) queryParams.append("type", params.type);
      if (params.startDate) queryParams.append("startDate", params.startDate);
      if (params.endDate) queryParams.append("endDate", params.endDate);

      const queryString = queryParams.toString();
      const url = `admin/users/notification-history${
        queryString ? `?${queryString}` : ""
      }`;
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },
  // Promotional messaging methods
  getBoostHistory: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append("page", params.page);
      if (params.limit) queryParams.append("limit", params.limit);
      if (params.user_id) queryParams.append("user_id", params.user_id);
      if (params.action) queryParams.append("action", params.action);
      if (params.start_date)
        queryParams.append("start_date", params.start_date);
      if (params.end_date) queryParams.append("end_date", params.end_date);
      if (params.search) queryParams.append("search", params.search);

      const queryString = queryParams.toString();
      const url = `admin/users/boost-history${
        queryString ? `?${queryString}` : ""
      }`;
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },
  searchUserForPromotionalMessage: async (email = null, contactNo = null) => {
    try {
      const queryParams = new URLSearchParams();
      if (email) queryParams.append("email", email);
      if (contactNo) queryParams.append("contactNo", contactNo);

      const queryString = queryParams.toString();
      const url = `admin/users/promotional/search-user${
        queryString ? `?${queryString}` : ""
      }`;
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },
  sendPromotionalMessageToUser: async (payload) => {
    try {
      const response = await axiosInstance.post(
        "admin/users/promotional/send-to-user",
        payload
      );
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },
  sendPromotionalMessageToAll: async (payload) => {
    try {
      const response = await axiosInstance.post(
        "admin/users/promotional/send-to-all",
        payload
      );
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },
  uploadPromotionalVideo: async (file) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      const response = await axiosInstance.post(
        "admin/users/promotional/upload/video",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },
};

export default adminService;
